<template>
    <div class="card bg-white shadow border-0"
         :class="[{'height-100': heightFull}, classes]">
        <div class="card-header bg-lighter border-0 p-3" :class="headerClasses" v-if="title">
          <h4 class="mb-0 text-primary-2 card-title">{{ title }}</h4>
        </div>
        <div class="card-body px-lg-3 py-lg-3" :class="bodyClasses">
            <slot></slot>
        </div>
    </div>
</template>
<script>
export default {
  name: "base-card",
  props: {
    type: {
      type: String,
      description: "Card classes"
    },
    classes: {
      type: String,
      description: "Card classes"
    },
    heightFull: {
      type: Boolean,
      default: true,
      description: "Card classes"
    },
    title: {
      type: String,
      description: "Card title"
    },
    bodyClasses: {
      type: [String, Object, Array],
      description: "Card body css classes"
    },
    headerClasses: {
      type: [String, Object, Array],
      description: "Card header css classes"
    },
    footerClasses: {
      type: [String, Object, Array],
      description: "Card footer css classes"
    }
  }
};
</script>
<style>
</style>
